(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-nf-sale-page]';
  var state = { discount: 'all', category: 'all' };

  function twoDigits(value) {
    var text = String(Math.max(0, value));
    return text.length < 2 ? '0' + text : text.slice(-2);
  }

  function setFlipDigit(unit, value, reduceMotion) {
    if (!unit || unit.dataset.value === value) return;

    var previous = unit.dataset.value || '0';
    var top = unit.querySelector('[data-nf-flip-top]');
    var bottom = unit.querySelector('[data-nf-flip-bottom]');
    var from = unit.querySelector('[data-nf-flip-from]');
    var to = unit.querySelector('[data-nf-flip-to]');
    var lowerFlap = unit.querySelector('.nf-sale-flip__flipper--bottom');

    unit.dataset.value = value;
    if (!top || !bottom || !from || !to || !lowerFlap || reduceMotion) {
      [top, bottom, from, to].forEach(function (part) {
        if (part) part.textContent = value;
      });
      return;
    }

    top.textContent = previous;
    bottom.textContent = value;
    from.textContent = previous;
    to.textContent = value;
    unit.classList.remove('is-flipping');
    void unit.offsetWidth;
    unit.classList.add('is-flipping');

    lowerFlap.addEventListener('animationend', function finishFlip() {
      top.textContent = value;
      from.textContent = value;
      unit.classList.remove('is-flipping');
    }, { once: true });
  }

  function initialiseCountdown(countdown) {
    if (!countdown || countdown.dataset.nfSaleCountdownReady === 'true') return;

    var target = new Date(countdown.dataset.endAt || '').getTime();
    if (!Number.isFinite(target)) return;
    countdown.dataset.nfSaleCountdownReady = 'true';

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer;

    function update() {
      if (!countdown.isConnected) {
        window.clearInterval(timer);
        return;
      }

      var remaining = Math.max(0, Math.floor((target - Date.now()) / 1000));
      var values = {
        days: twoDigits(Math.floor(remaining / 86400)),
        hours: twoDigits(Math.floor((remaining % 86400) / 3600)),
        minutes: twoDigits(Math.floor((remaining % 3600) / 60)),
        seconds: twoDigits(remaining % 60)
      };

      Object.keys(values).forEach(function (part) {
        values[part].split('').forEach(function (digit, index) {
          setFlipDigit(countdown.querySelector('[data-nf-countdown-digit="' + part + '-' + index + '"]'), digit, reduceMotion);
        });
      });

      if (remaining === 0) {
        countdown.classList.add('is-ended');
        var summary = countdown.querySelector('[data-nf-sale-countdown-summary]');
        if (summary) summary.textContent = 'The Grand Opening offer has ended.';
        window.clearInterval(timer);
      }
    }

    update();
    if (!countdown.classList.contains('is-ended')) timer = window.setInterval(update, 1000);
  }

  function createCount(value) {
    var count = document.createElement('b');
    count.textContent = String(value);
    return count;
  }

  function createCategoryButton(label, slug, count) {
    var button = document.createElement('button');
    var text = document.createElement('span');
    button.type = 'button';
    button.dataset.nfSaleCategory = slug;
    button.setAttribute('aria-pressed', 'false');
    text.textContent = label;
    button.appendChild(text);
    button.appendChild(createCount(count));
    return button;
  }

  function createDiscountButton(percent, count) {
    var button = document.createElement('button');
    var seal = document.createElement('span');
    var copy = document.createElement('span');
    var title = document.createElement('b');
    var detail = document.createElement('small');
    button.type = 'button';
    button.className = 'nf-sale-discount';
    button.dataset.nfSaleDiscount = String(percent);
    button.setAttribute('aria-pressed', 'false');
    seal.className = 'nf-sale-discount__seal';
    seal.textContent = percent + '%';
    title.textContent = 'OFF';
    detail.textContent = count + (count === 1 ? ' product' : ' products');
    copy.appendChild(title);
    copy.appendChild(detail);
    button.appendChild(seal);
    button.appendChild(copy);
    return button;
  }

  function getCards(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-nf-sale-card]'));
  }

  function collectData(cards) {
    var discounts = {};
    var categories = {};
    var discounted = cards.filter(function (card) {
      return Number(card.dataset.nfSaleDiscount || 0) > 0;
    });

    discounted.forEach(function (card) {
      var discount = String(Number(card.dataset.nfSaleDiscount));
      var slug = card.dataset.nfSaleCategory || 'other-sale-floors';
      var label = card.dataset.nfSaleCategoryLabel || 'Other sale floors';
      discounts[discount] = (discounts[discount] || 0) + 1;
      if (!categories[slug]) categories[slug] = { label: label, count: 0 };
      categories[slug].count += 1;
    });

    return { cards: discounted, discounts: discounts, categories: categories };
  }

  function buildControls(root, data) {
    var categoryLists = root.querySelectorAll('[data-nf-sale-category-list]');
    var discountLists = root.querySelectorAll('[data-nf-sale-discount-list]');
    var categoryKeys = Object.keys(data.categories);
    var discountKeys = Object.keys(data.discounts).sort(function (a, b) { return Number(b) - Number(a); });

    Array.prototype.forEach.call(categoryLists, function (list) {
      list.replaceChildren();
      categoryKeys.forEach(function (slug) {
        var category = data.categories[slug];
        list.appendChild(createCategoryButton(category.label, slug, category.count));
      });
    });

    Array.prototype.forEach.call(discountLists, function (list) {
      list.replaceChildren();
      discountKeys.forEach(function (percent) {
        list.appendChild(createDiscountButton(percent, data.discounts[percent]));
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-nf-sale-all-count], [data-nf-sale-discount-all-count]'), function (count) {
      count.textContent = String(data.cards.length);
    });

    var max = discountKeys.length ? Number(discountKeys[0]) : 0;
    Array.prototype.forEach.call(root.querySelectorAll('[data-nf-sale-max]'), function (value) {
      value.textContent = String(max);
    });
  }

  function syncButtons(root) {
    Array.prototype.forEach.call(document.querySelectorAll('button[data-nf-sale-discount]'), function (button) {
      var active = button.dataset.nfSaleDiscount === state.discount;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    Array.prototype.forEach.call(document.querySelectorAll('button[data-nf-sale-category]'), function (button) {
      var active = button.dataset.nfSaleCategory === state.category;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-nf-sale-clear]'), function (button) {
      button.hidden = state.discount === 'all' && state.category === 'all';
    });
  }

  function applyFilters(root) {
    var data = collectData(getCards(root));
    var visible = 0;
    data.cards.forEach(function (card, index) {
      var discountMatch = state.discount === 'all' || card.dataset.nfSaleDiscount === state.discount;
      var categoryMatch = state.category === 'all' || card.dataset.nfSaleCategory === state.category;
      var show = discountMatch && categoryMatch;
      card.hidden = !show;
      card.setAttribute('aria-hidden', String(!show));
      if (show) {
        card.style.setProperty('--nf-sale-index', String(index));
        visible += 1;
      }
    });

    getCards(root).filter(function (card) { return Number(card.dataset.nfSaleDiscount || 0) <= 0; }).forEach(function (card) {
      card.hidden = true;
      card.setAttribute('aria-hidden', 'true');
    });

    var empty = root.querySelector('[data-nf-sale-empty]');
    if (!empty) {
      empty = document.createElement('li');
      empty.className = 'nf-sale-empty';
      empty.dataset.nfSaleEmpty = '';
      var heading = document.createElement('h2');
      var text = document.createElement('p');
      heading.textContent = 'No live offers match both filters.';
      text.textContent = 'Choose another saving or product category.';
      empty.appendChild(heading);
      empty.appendChild(text);
      var grid = root.querySelector('[data-productgrid-items]');
      if (grid) grid.appendChild(empty);
    }
    empty.hidden = visible !== 0;

    Array.prototype.forEach.call(root.querySelectorAll('[data-nf-sale-status]'), function (status) {
      status.textContent = 'Showing ' + visible + ' of ' + data.cards.length + ' live sale products on this page.';
    });
    syncButtons(root);
  }

  function bringResultsIntoView(root) {
    var grid = root.querySelector('#nf-sale-products');
    if (!grid) return;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.requestAnimationFrame(function () {
      grid.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function initialiseShowcase(root) {
    var showcase = root.querySelector('[data-nf-sale-showcase]');
    if (!showcase || showcase.dataset.nfSaleShowcaseReady === 'true') return;

    var cards = Array.prototype.slice.call(showcase.querySelectorAll('[data-nf-sale-showcase-card]'));
    var triggers = cards.map(function (card) {
      return card.querySelector('[data-nf-sale-showcase-trigger]');
    });
    var activeIndex = -1;
    var hoverLockedUntil = 0;
    if (!cards.length) return;

    showcase.dataset.nfSaleShowcaseReady = 'true';

    function activate(index, moveFocus) {
      if (index !== activeIndex) hoverLockedUntil = Date.now() + 700;
      activeIndex = index;
      cards.forEach(function (card, cardIndex) {
        var active = cardIndex === index;
        var trigger = triggers[cardIndex];
        var panel = card.querySelector('.nf-sale-showcase__panel');
        card.classList.toggle('is-active', active);
        if (trigger) trigger.setAttribute('aria-expanded', String(active));
        if (panel) panel.setAttribute('aria-hidden', String(!active));
      });
      if (moveFocus && triggers[index]) triggers[index].focus();
    }

    cards.forEach(function (card, index) {
      var trigger = triggers[index];
      if (!trigger) return;

      trigger.addEventListener('click', function () { activate(index, false); });
      trigger.addEventListener('focus', function () { activate(index, false); });
      card.addEventListener('mouseenter', function () {
        if (
          Date.now() >= hoverLockedUntil &&
          window.matchMedia &&
          window.matchMedia('(hover: hover) and (pointer: fine)').matches
        ) {
          activate(index, false);
        }
      });
      trigger.addEventListener('keydown', function (event) {
        var next = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % cards.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + cards.length) % cards.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = cards.length - 1;
        else return;
        event.preventDefault();
        activate(next, true);
      });
    });

    var initial = cards.findIndex(function (card) { return card.classList.contains('is-active'); });
    activate(initial < 0 ? 0 : initial, false);
  }

  function initialise(root) {
    if (!root || root.querySelector('[data-nf-warehouse]') || root.dataset.nfSaleReady === 'true') return;
    var cards = getCards(root);
    if (!cards.length) return;
    root.dataset.nfSaleReady = 'true';
    initialiseShowcase(root);
    var data = collectData(cards);
    buildControls(root, data);
    applyFilters(root);

    if (document.documentElement.dataset.nfSaleHandlers !== 'true') {
      document.documentElement.dataset.nfSaleHandlers = 'true';
      document.addEventListener('click', function (event) {
        var discount = event.target.closest('button[data-nf-sale-discount]');
        var category = event.target.closest('button[data-nf-sale-category]');
        var clear = event.target.closest('[data-nf-sale-clear]');
        if (!discount && !category && !clear) return;

        var activeRoot = document.querySelector(ROOT_SELECTOR);
        if (!activeRoot) return;
        if (discount) {
          state.discount = discount.dataset.nfSaleDiscount;
          state.category = 'all';
        }
        else if (category) {
          state.category = category.dataset.nfSaleCategory;
          state.discount = 'all';
        }
        else state = { discount: 'all', category: 'all' };
        applyFilters(activeRoot);
        if (discount || category || clear) bringResultsIntoView(activeRoot);
      });
    }
  }

  function initialiseAll() {
    Array.prototype.forEach.call(document.querySelectorAll(ROOT_SELECTOR), initialise);
    Array.prototype.forEach.call(document.querySelectorAll('[data-nf-sale-countdown]'), initialiseCountdown);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll);
  else initialiseAll();
  document.addEventListener('shopify:section:load', initialiseAll);
})();
